import { ServiceDeliveryStatus } from "../../../../features/Booking-Form/typings/booking-service-administration.types";
import { BookingRequestsStatus } from "../../../BookingRequest/typings/booking-requests.types";
import type { ResourceKind } from "../../../../features/Schedule/typings/resource-calendar.types";

export type OrderRequestData = {
  id: number;
  bookingId: string;
  date: string;
  timeFrom: string;
  timeTo: string;
  placeOrZoneType: PlaceOrZoneType;
  inventoryName: string;
  locationName: string;
  /** When present (e.g. from service-booking detail API), used for service-admin checks. */
  locationInventoryId?: number | null;
  floorName: string;
  numberOfCaterings: number;
  numberOfBookableEquipments: number;
  numberOfRoomLayouts: number;
  requestedByUser: string;
  /** Present on standalone resource parent bookings from weplace. */
  resourceKind?: ResourceKind;
  /** When the API provides who cancelled the booking; otherwise UI falls back to `requestedByUser`. */
  cancelledByUser?: string | null;
  status: BookingRequestsStatus;
  deliveryStatus: ServiceDeliveryStatus;
};

export enum PlaceOrZoneType {
  Place = "place",
  Zone = "zone",
  Resource = "resource"
}

export type DetailedServiceCatering = {
  id: number;
  serviceId: number;
  name: string;
  image: string | null;
  description: string;
  pricePerUnit: number;
  quantity: number; // delivering result
  orderedQty: number;
  availableQty: number | null;
  status: BookingRequestsStatus;
  deliveryStatus: ServiceDeliveryStatus;
  setupTime: number;
  bookingLeadTime: number;
};

export type DetailedServiceBookableEquipment = {
  id: number;
  serviceId: number;
  name: string;
  image: string | null;
  category: string;
  setupTime: number;
  bookingLeadTime?: number;
  quantity: number;
  status: BookingRequestsStatus;
  deliveryStatus: ServiceDeliveryStatus;
  description?: string;
  costPerHour?: number;
};

export type DetailedServiceRoomLayout = {
  id: number;
  serviceId: number;
  arrangement: boolean[][];
  setupTime: number;
  quantity: number;
  status: BookingRequestsStatus;
  deliveryStatus: ServiceDeliveryStatus;
  picturePath?: string | null;
  picturePaths?: (string | null)[] | null;
};

export type DetailedServiceBookingData = OrderRequestData & {
  /** Set by service-booking detail API for merging assigned-but-unordered services. */
  bookingInventoryId?: number;
  /** Floor id for `/plan/:id/services` when resolvable from the booking inventory. */
  floorInventoryId?: number | null;
  caterings: DetailedServiceCatering[];
  equipments: DetailedServiceBookableEquipment[];
  roomLayouts: DetailedServiceRoomLayout[];
};
